export const regexp = new RegExp(/<(\w)+>/);
